import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import Card from '../../components/common/Card';
import BarChart from '../../components/DashboardComponent/BarChart';
import PieChart from '../../components/common/PieChart/PieChart';
import Tab from '../../components/common/Tab/Tab';
import { convertToLocalCurrency } from '../../utils/currency';

import { Container, CardWrapper, ChartWrapper, TableWrapper } from './DashboardStyles';
import { getTopBoard } from '../../redux/slices/overviewSlice';
import { getUserProfile } from '../../redux/slices/userSlice';

const Dashboard = () => {
  const dispatch = useDispatch();
  const { topboard } = useSelector((state) => state.overview);
  const { user } = useSelector((state) => state.user);

  useEffect(() => {
    dispatch(getUserProfile());
    dispatch(getTopBoard({}));
  }, [dispatch]);

  return (
    <Container>
      <div className='heading'>
        <h1>Hey, {user.data?.firstName}</h1>
        <p>Track and manage your campaigns.</p>
      </div>
        <CardWrapper>
          <Card text={'Total no of Campaigns'} totalCount={topboard?.totalCampaigns} />
          <Card text={'Approved Campaigns'} totalCount={topboard?.approvedCampaigns} />
          <Card text={'Money spent'} totalCount={convertToLocalCurrency(`${topboard?.moneySpent}`)} />
        </CardWrapper>

      <h3>Campaign Analytics</h3>
      <ChartWrapper>
        <div className='left'>
          <BarChart />
        </div>
        <div className='right'>
          <PieChart />
        </div>
      </ChartWrapper>

      <TableWrapper>
        <div className='header'>
          <div className='texts'>
            <h3>Best Performing Campaigns</h3>
            <p>Keep track of your Ads with DigiClick</p>
          </div>
          <div className='link-buttons'>
            <Link className='see-more' to="/campaigns">See More</Link>
            <Link className='add-campaign'to="create-campaign">+ Create Campaign</Link>
          </div>
        </div>
        <Tab dashbord />
      </TableWrapper>
    </Container>
  );
};

export default Dashboard;
